export const ROUTE_PATHS = {
  IASTART: '/iastart',
  IADOCS: '/iadocs',
  IADOCS_DEBUG: '/iadocs/debug',
  IADOCS_EXTRACT: '/iadocs/extract',
  IADOCS_TYPING: '/iadocs/typing',
  IADOCS_UNBUNDLE: '/iadocs/unbundle',
  ERROR: '/error',
}
